var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestaurants(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99995 8.79527C9.99995 9.76974 9.53606 9.99462 8.96384 9.99462C8.39162 9.99462 7.92773 9.76697 7.92773 8.79527C7.92773 7.82357 8.39162 6.46875 8.96384 6.46875C9.53606 6.46875 9.99995 7.8208 9.99995 8.79527Z",
    fill: "url(#paint0_radial_9478_21983)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.96395 6.46875C8.93895 6.46875 8.91395 6.47153 8.88895 6.47708C9.22228 6.5798 9.46395 7.35716 9.07784 7.32107C9.07784 7.32107 9.38895 7.62091 9.23339 7.82635C9.23339 7.82635 9.49728 8.03179 9.28895 8.37883C9.11673 8.66201 8.94728 8.6398 8.94728 8.6398C8.94728 8.6398 8.98339 8.98684 8.71673 9.08956C8.5334 9.16174 8.26118 9.44215 8.1084 9.6115C8.16951 9.70867 8.24451 9.78363 8.33062 9.84193L8.83617 9.99462C8.87784 9.9974 8.91951 10.0002 8.96395 10.0002C9.53617 10.0002 10.0001 9.77252 10.0001 8.80082C10.0001 7.8208 9.53617 6.46875 8.96395 6.46875Z",
    fill: "url(#paint1_linear_9478_21983)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33569 9.32365C8.87181 9.62349 8.53014 9.40694 8.06348 9.52632C8.24125 9.89279 8.57736 9.99551 8.96347 9.99551C9.53569 9.99551 9.99958 9.76785 9.99958 8.79616C9.99958 8.20203 9.82736 7.46354 9.56069 6.98047C9.83847 7.85222 9.90236 8.95718 9.33569 9.32365Z",
    fill: "url(#paint2_radial_9478_21983)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07221 8.79527C2.07221 9.76974 1.60832 9.99462 1.03611 9.99462C0.463886 9.99462 0 9.76697 0 8.79527C0 7.82357 0.463886 6.46875 1.03611 6.46875C1.60832 6.46875 2.07221 7.8208 2.07221 8.79527Z",
    fill: "url(#paint3_radial_9478_21983)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03622 6.46875C1.01122 6.46875 0.986215 6.47153 0.961216 6.47708C1.29455 6.5798 1.53621 7.35716 1.1501 7.32107C1.1501 7.32107 1.46121 7.62091 1.30566 7.82635C1.30566 7.82635 1.56955 8.03179 1.36121 8.37883C1.18899 8.66201 1.01955 8.6398 1.01955 8.6398C1.01955 8.6398 1.05566 8.98684 0.788994 9.08956C0.605662 9.15896 0.333441 9.43937 0.180664 9.60872C0.241775 9.70589 0.316774 9.78085 0.402885 9.83915L0.908438 9.99185C0.950105 9.99462 0.991771 9.9974 1.03622 9.9974C1.60843 9.9974 2.07232 9.76975 2.07232 8.79805C2.07232 7.8208 1.60843 6.46875 1.03622 6.46875Z",
    fill: "url(#paint4_linear_9478_21983)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40503 9.32365C0.941141 9.62349 0.599477 9.40694 0.132812 9.52632C0.310589 9.89279 0.646699 9.99551 1.03281 9.99551C1.60503 9.99551 2.06891 9.76785 2.06891 8.79616C2.06891 8.20203 1.89669 7.46354 1.63003 6.98047C1.9078 7.85222 1.97447 8.95718 1.40503 9.32365Z",
    fill: "url(#paint5_radial_9478_21983)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72521 3.22235L7.61133 2.94472V1.04297H8.72521V3.22235Z",
    fill: "url(#paint6_linear_9478_21983)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37521 1.55658V3.13628L8.72799 3.22512V1.04297H7.61133V1.22898H8.04466C8.22799 1.22898 8.37521 1.37612 8.37521 1.55658Z",
    fill: "url(#paint7_linear_9478_21983)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6558 4.06028L5.00026 0.998047L1.34473 4.06028V9.99597H8.6558V4.06028Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.6558 4.06028L5.00026 0.998047L1.34473 4.06028V9.99597H8.6558V4.06028Z",
    fill: "url(#paint8_linear_9478_21983)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75598 3.05845C5.66987 2.72252 5.36432 2.47266 5.00043 2.47266C4.63654 2.47266 4.33099 2.72252 4.24488 3.05845H4.22266V3.25279C4.22266 3.68311 4.57265 4.03292 5.00321 4.03292C5.43376 4.03292 5.78376 3.68311 5.78376 3.25279V3.05845H5.75598Z",
    fill: "url(#paint9_linear_9478_21983)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40017 8.54297H8.60014C8.66125 8.54297 8.71125 8.59294 8.71125 8.65402V9.99496H1.28906V8.65402C1.28906 8.59294 1.33906 8.54297 1.40017 8.54297Z",
    fill: "url(#paint10_linear_9478_21983)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71402 9.56836H1.28906V9.59612H8.71402V9.56836Z",
    fill: "url(#paint11_linear_9478_21983)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71402 9.05664H1.28906V9.0844H8.71402V9.05664Z",
    fill: "url(#paint12_linear_9478_21983)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60013 8.54297H1.40017C1.33906 8.54297 1.28906 8.59294 1.28906 8.65402H8.71402C8.71125 8.59294 8.66125 8.54297 8.60013 8.54297Z",
    fill: "url(#paint13_linear_9478_21983)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66118 4.9375H2.14453V9.97367H4.66118V4.9375Z",
    fill: "url(#paint14_linear_9478_21983)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35547 5.17065V9.75984H2.37769V5.17065H4.45268V5.14844H2.37769H2.35547V5.17065Z",
    fill: "#643800"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2.35547 9.75984H4.43046H4.45268V5.14844L4.43046 5.17065V9.73763H2.37769L2.35547 9.75984Z",
    fill: "url(#paint15_linear_9478_21983)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4307 9.73495H2.37793V5.16797H4.4307V9.73495Z",
    fill: "url(#paint16_radial_9478_21983)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8968 5.16797H2.84961V9.23244H2.8968V5.16797Z",
    fill: "url(#paint17_linear_9478_21983)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42708 5.16797H3.37988V9.23244H3.42708V5.16797Z",
    fill: "url(#paint18_linear_9478_21983)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9554 5.16797H3.9082V9.23244H3.9554V5.16797Z",
    fill: "url(#paint19_linear_9478_21983)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M0.555577 3.87509L0.411133 3.58913L1.49724 2.83398V3.55582L0.555577 3.87509Z",
    fill: "url(#paint20_linear_9478_21983)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M1.49707 3.11558V2.71024L2.66373 1.90234V2.6214L1.49707 3.11558Z",
    fill: "url(#paint21_linear_9478_21983)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66406 2.14487V1.74231L3.8335 0.931641V1.65347L2.66406 2.14487Z",
    fill: "url(#paint22_linear_9478_21983)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M3.83301 1.21323V0.807897L4.99967 0V0.719056L3.83301 1.21323Z",
    fill: "url(#paint23_linear_9478_21983)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44474 3.87509L9.58919 3.58913L8.50586 2.83398V3.55582L9.44474 3.87509Z",
    fill: "url(#paint24_linear_9478_21983)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50538 3.11558V2.71024L7.33594 1.90234V2.6214L8.50538 3.11558Z",
    fill: "url(#paint25_linear_9478_21983)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33658 2.14487V1.74231L6.16992 0.931641V1.65347L7.33658 2.14487Z",
    fill: "url(#paint26_linear_9478_21983)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16944 1.21323V0.807897L5 0V0.719056L6.16944 1.21323Z",
    fill: "url(#paint27_linear_9478_21983)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00008 0.99551L8.98895 4.33537L9.44451 3.87451L5.00008 0.154297L0.555664 3.87451L1.01122 4.33537L5.00008 0.99551Z",
    fill: "url(#paint28_linear_9478_21983)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00008 0.320874L9.34728 3.96057L9.44451 3.87451L5.00008 0.154297L0.555664 3.87451L0.641775 3.96057L5.00008 0.320874Z",
    fill: "url(#paint29_linear_9478_21983)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1056 4.21828L5.00007 0.78125L0.894531 4.21828L1.0112 4.33766L5.00007 0.9978L8.98893 4.33766L9.1056 4.21828Z",
    fill: "url(#paint30_linear_9478_21983)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1.34473 4.44896L5.00026 1.3895L8.6558 4.44896V4.06028L5.00026 0.998047L1.34473 4.06028V4.44896Z",
    fill: "url(#paint31_linear_9478_21983)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4307 5.17383H2.37793V5.30709V9.94903H2.43348V5.30709H4.37514V9.92682H4.4307V5.17383Z",
    fill: "url(#paint32_linear_9478_21983)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.68306 8.99219H2.12196C2.09141 8.99219 2.06641 9.01717 2.06641 9.04771V9.99442H4.73861V9.04771C4.73861 9.01717 4.71361 8.99219 4.68306 8.99219Z",
    fill: "url(#paint33_linear_9478_21983)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M5.01682 9.99429V9.52232C5.01682 9.49178 4.99182 9.4668 4.96127 9.4668H1.84462C1.81406 9.4668 1.78906 9.49178 1.78906 9.52232V9.99429",
    fill: "url(#paint34_linear_9478_21983)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71143 0.607422H7.62533C7.5781 0.607422 7.54199 0.643513 7.54199 0.69071V1.01553C7.54199 1.03219 7.5531 1.0433 7.56977 1.0433H8.76699C8.78365 1.0433 8.79476 1.03219 8.79476 1.01553V0.69071C8.79476 0.64629 8.75865 0.607422 8.71143 0.607422Z",
    fill: "url(#paint35_linear_9478_21983)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49698 6.83061C3.48032 6.79452 3.4442 6.76953 3.40254 6.76953C3.36087 6.76953 3.32476 6.79452 3.30809 6.83061C3.18865 6.86948 3.10254 6.98053 3.10254 7.11379C3.10254 7.27759 3.23587 7.41085 3.39976 7.41085C3.56365 7.41085 3.69698 7.27759 3.69698 7.11379C3.70254 6.98053 3.61643 6.86948 3.49698 6.83061ZM3.40254 7.32201C3.28587 7.32201 3.19143 7.22762 3.19143 7.11101C3.19143 7.02495 3.24143 6.95277 3.31365 6.91945C3.33032 6.94999 3.36365 6.9722 3.40254 6.9722C3.44143 6.9722 3.47198 6.94999 3.49143 6.91945C3.56365 6.95277 3.61365 7.02495 3.61365 7.11101C3.61365 7.22762 3.5192 7.32201 3.40254 7.32201Z",
    fill: "url(#paint36_linear_9478_21983)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40269 6.73242C3.2388 6.73242 3.10547 6.86568 3.10547 7.02948C3.10547 7.19328 3.2388 7.32655 3.40269 7.32655C3.56658 7.32655 3.69991 7.19328 3.69991 7.02948C3.70269 6.86568 3.56935 6.73242 3.40269 6.73242ZM3.40269 7.24048C3.28602 7.24048 3.19158 7.14609 3.19158 7.02948C3.19158 6.91288 3.28602 6.81849 3.40269 6.81849C3.51935 6.81849 3.6138 6.91288 3.6138 7.02948C3.6138 7.14609 3.51935 7.24048 3.40269 7.24048Z",
    fill: "url(#paint37_radial_9478_21983)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40252 6.7832C3.28585 6.7832 3.19141 6.8776 3.19141 6.9942C3.19141 6.99975 3.19141 7.00531 3.19141 7.01086C3.19974 6.90258 3.29141 6.81652 3.40252 6.81652C3.51363 6.81652 3.60251 6.90258 3.61363 7.01086C3.61363 7.00531 3.61363 6.99975 3.61363 6.9942C3.61363 6.8776 3.51918 6.7832 3.40252 6.7832Z",
    fill: "url(#paint38_linear_9478_21983)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40269 7.29212C3.24436 7.29212 3.1138 7.16719 3.10547 7.01172C3.10547 7.01727 3.10547 7.02282 3.10547 7.02838C3.10547 7.19218 3.2388 7.32544 3.40269 7.32544C3.56658 7.32544 3.69991 7.19218 3.69991 7.02838C3.69991 7.02282 3.69991 7.01727 3.69991 7.01172C3.69158 7.16719 3.56102 7.29212 3.40269 7.29212Z",
    fill: "url(#paint39_linear_9478_21983)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40252 6.89099C3.45926 6.89099 3.50525 6.845 3.50525 6.78827C3.50525 6.73154 3.45926 6.68555 3.40252 6.68555C3.34579 6.68555 3.2998 6.73154 3.2998 6.78827C3.2998 6.845 3.34579 6.89099 3.40252 6.89099Z",
    fill: "url(#paint40_radial_9478_21983)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00028 2.28125C4.56972 2.28125 4.21973 2.63106 4.21973 3.06138C4.21973 3.49171 4.56972 3.84152 5.00028 3.84152C5.43083 3.84152 5.78083 3.49171 5.78083 3.06138C5.78083 2.63106 5.43083 2.28125 5.00028 2.28125ZM5.00028 3.7971C4.59195 3.7971 4.26139 3.46672 4.26139 3.05861C4.26139 2.65049 4.59195 2.32012 5.00028 2.32012C5.40861 2.32012 5.73916 2.65049 5.73916 3.05861C5.73916 3.46672 5.40861 3.7971 5.00028 3.7971Z",
    fill: "url(#paint41_linear_9478_21983)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99956 2.46094C4.66901 2.46094 4.40234 2.72746 4.40234 3.05784C4.40234 3.38821 4.66901 3.65474 4.99956 3.65474C5.33012 3.65474 5.59678 3.38821 5.59678 3.05784C5.59678 2.72746 5.33012 2.46094 4.99956 2.46094ZM4.99956 3.61587C4.69123 3.61587 4.44401 3.366 4.44401 3.06061C4.44401 2.75245 4.69401 2.50536 4.99956 2.50536C5.30789 2.50536 5.55511 2.75522 5.55511 3.06061C5.55789 3.366 5.30789 3.61587 4.99956 3.61587Z",
    fill: "url(#paint42_linear_9478_21983)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99963 2.32422C4.5913 2.32422 4.26074 2.6546 4.26074 3.06271C4.26074 3.47082 4.5913 3.8012 4.99963 3.8012C5.40796 3.8012 5.73852 3.47082 5.73852 3.06271C5.73852 2.6546 5.40796 2.32422 4.99963 2.32422ZM4.99963 3.64573C4.67741 3.64573 4.4163 3.38476 4.4163 3.06271C4.4163 2.74066 4.67741 2.47969 4.99963 2.47969C5.32185 2.47969 5.58296 2.74066 5.58296 3.06271C5.58296 3.38476 5.32463 3.64573 4.99963 3.64573Z",
    fill: "url(#paint43_linear_9478_21983)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99989 3.61442C5.30671 3.61442 5.55544 3.36582 5.55544 3.05916C5.55544 2.7525 5.30671 2.50391 4.99989 2.50391C4.69307 2.50391 4.44434 2.7525 4.44434 3.05916C4.44434 3.36582 4.69307 3.61442 4.99989 3.61442Z",
    fill: "url(#paint44_linear_9478_21983)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99989 2.69547C5.25267 2.69547 5.46655 2.85094 5.55544 3.07027C5.55544 3.06749 5.55544 3.06471 5.55544 3.05916C5.55544 2.75099 5.30544 2.50391 4.99989 2.50391C4.69156 2.50391 4.44434 2.75377 4.44434 3.05916C4.44434 3.06194 4.44434 3.06471 4.44434 3.07027C4.53322 2.85094 4.74989 2.69547 4.99989 2.69547Z",
    fill: "url(#paint45_linear_9478_21983)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66659 6.31137L5.2666 7.71061V7.90495L8.04714 7.89385V7.69951L6.66937 6.30859",
    fill: "url(#paint46_linear_9478_21983)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M8.02778 4.94727H5.28613V7.68746H8.02778V4.94727Z",
    fill: "url(#paint47_linear_9478_21983)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04699 7.6854V4.92578H8.02477V7.6854H5.26367V7.70761H8.02477H8.04699V7.6854Z",
    fill: "url(#paint48_linear_9478_21983)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04699 4.92578H5.28589H5.26367V7.70761L5.28589 7.6854V4.94799H8.02477L8.04699 4.92578Z",
    fill: "url(#paint49_linear_9478_21983)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49414 5.17846V7.47444H5.51636V5.17846H7.81357V5.15625H5.51636H5.49414V5.17846Z",
    fill: "#643800"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49414 7.47444H7.79135H7.81357V5.15625L7.79135 5.17846V7.45223H5.51636L5.49414 7.47444Z",
    fill: "#C86F34"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79159 7.4515H5.5166V5.17773H7.79159V7.4515Z",
    fill: "url(#paint50_linear_9478_21983)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79175 6.22266C7.40008 6.68074 6.81675 6.77791 6.52231 6.64743C6.31953 6.55859 5.91397 6.50306 5.51953 6.5808V7.45255H7.79452V6.22266H7.79175Z",
    fill: "url(#paint51_linear_9478_21983)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79159 7.45346H5.5166V5.17969H7.79159V7.45346Z",
    fill: "url(#paint52_radial_9478_21983)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5166 5.17969V7.45346H5.59993V5.34626C5.59993 5.31573 5.62493 5.29074 5.65549 5.29074H6.4916C6.50826 5.29074 6.51937 5.30184 6.51937 5.3185V7.45346H6.85826V5.3185C6.85826 5.30184 6.86937 5.29074 6.88604 5.29074H7.6527C7.68326 5.29074 7.70826 5.31573 7.70826 5.34626V7.45346H7.79159V5.17969H5.5166Z",
    fill: "url(#paint53_linear_9478_21983)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79159 5.31099H5.5166V5.17773H7.79159V5.31099Z",
    fill: "url(#paint54_linear_9478_21983)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79678 5.17383V7.4587H6.58301V5.17383H6.79678Z",
    fill: "url(#paint55_radial_9478_21983)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M6.79678 5.17383V5.37927H6.58301V5.17383H6.79678Z",
    fill: "url(#paint56_linear_9478_21983)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44727 3.11529C4.47504 3.3957 4.71115 3.61502 5.00004 3.61502C5.30837 3.61502 5.55559 3.36516 5.55559 3.05977C5.55559 3.02923 5.55282 2.99869 5.54726 2.96815C5.13615 2.91818 5.04726 3.45677 4.44727 3.11529Z",
    fill: "url(#paint57_linear_9478_21983)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4307 5.17383H2.37793V5.7263H4.4307V5.17383Z",
    fill: "url(#paint58_linear_9478_21983)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M8.71143 0.607422H8.5781V0.62408C8.5781 0.776775 8.4531 0.901707 8.30032 0.901707H7.54199V1.01553C7.54199 1.03219 7.5531 1.0433 7.56977 1.0433H8.76699C8.78365 1.0433 8.79476 1.03219 8.79476 1.01553V0.69071C8.79476 0.64629 8.75865 0.607422 8.71143 0.607422Z",
    fill: "url(#paint59_linear_9478_21983)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9478_21983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.25175 7.48886) scale(2.22031 2.25152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B8C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9478_21983",
    x1: 9.60022,
    y1: 9.81381,
    x2: 8.04601,
    y2: 6.71774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B8C1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9478_21983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0.516319 2.52432 -1.53167 0.322178 8.86424 7.29383)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407817"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9478_21983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.32315 7.48886) scale(2.2203 2.25152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B8C1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9478_21983",
    x1: 1.67162,
    y1: 9.81381,
    x2: 0.117408,
    y2: 6.71774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B8C1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B8C1C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_9478_21983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0.516319 2.52432 -1.53167 0.322178 0.935368 7.29371)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#76AB50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#407817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9478_21983",
    x1: 8.09158,
    y1: 3.40696,
    x2: 8.18407,
    y2: 1.88925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    stopColor: "#F2BC37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3627,
    stopColor: "#E09A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#D38235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    stopColor: "#CB7434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9478_21983",
    x1: 8.16929,
    y1: -5.52871,
    x2: 8.16929,
    y2: 7.75204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9478_21983",
    x1: 1.34401,
    y1: 5.49767,
    x2: 8.65651,
    y2: 5.49767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD2A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCD2A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9478_21983",
    x1: 5.00142,
    y1: 2.61721,
    x2: 5.00142,
    y2: 4.23694,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EA5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EA5A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9478_21983",
    x1: 5.00015,
    y1: 9.96252,
    x2: 5.00015,
    y2: 8.51103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE7E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9478_21983",
    x1: 5.00015,
    y1: 9.38645,
    x2: 5.00015,
    y2: 9.9418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EA5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9478_21983",
    x1: 5.00015,
    y1: 8.87406,
    x2: 5.00015,
    y2: 9.42939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EA5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9478_21983",
    x1: 5.00015,
    y1: 9.07805,
    x2: 5.00015,
    y2: 8.39168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EA5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFDCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9478_21983",
    x1: 3.8298,
    y1: 12.3384,
    x2: 3.20408,
    y2: 5.1457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_9478_21983",
    x1: 3.40345,
    y1: 4.23338,
    x2: 3.40345,
    y2: 12.8313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_9478_21983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.55248 6.93896) scale(3.34259 3.3408)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3541E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_9478_21983",
    x1: 2.85041,
    y1: 7.20027,
    x2: 2.89831,
    y2: 7.20027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_9478_21983",
    x1: 3.37891,
    y1: 7.20027,
    x2: 3.4268,
    y2: 7.20027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_9478_21983",
    x1: 3.90823,
    y1: 7.20027,
    x2: 3.95612,
    y2: 7.20027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_9478_21983",
    x1: 0.954308,
    y1: 2.835,
    x2: 0.954308,
    y2: 3.87519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_9478_21983",
    x1: 2.08051,
    y1: 1.90219,
    x2: 2.08051,
    y2: 3.11444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_9478_21983",
    x1: 3.24897,
    y1: 0.932812,
    x2: 3.24897,
    y2: 2.14506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_9478_21983",
    x1: 4.4166,
    y1: 0,
    x2: 4.4166,
    y2: 1.21225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_9478_21983",
    x1: 9.048,
    y1: 2.835,
    x2: 9.048,
    y2: 3.87519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_9478_21983",
    x1: 7.92115,
    y1: 1.90219,
    x2: 7.92115,
    y2: 3.11444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_9478_21983",
    x1: 6.75367,
    y1: 0.932812,
    x2: 6.75367,
    y2: 2.14506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_9478_21983",
    x1: 5.58506,
    y1: 1.33315e-8,
    x2: 5.58506,
    y2: 1.21225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_9478_21983",
    x1: 5.00008,
    y1: -2.22048,
    x2: 5.00008,
    y2: 3.93709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_9478_21983",
    x1: 5.00008,
    y1: 1.25653,
    x2: 5.00008,
    y2: 6.50614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_9478_21983",
    x1: 5.00006,
    y1: 1.21245,
    x2: 5.00006,
    y2: 5.71772,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_9478_21983",
    x1: 5.00026,
    y1: 4.85772,
    x2: 5.00026,
    y2: -1.90571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7A4400",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_9478_21983",
    x1: 1.60181,
    y1: 1.74427,
    x2: 5.25061,
    y2: 13.5366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_9478_21983",
    x1: 3.40327,
    y1: 8.99273,
    x2: 3.40327,
    y2: 9.99442,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    stopColor: "#F2BC37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3627,
    stopColor: "#E09A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#D38235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    stopColor: "#CB7434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_9478_21983",
    x1: 3.4037,
    y1: 9.46562,
    x2: 3.4037,
    y2: 9.99429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    stopColor: "#F2BC37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3627,
    stopColor: "#E09A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#D38235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    stopColor: "#CB7434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_9478_21983",
    x1: 7.46698,
    y1: -0.790132,
    x2: 8.88149,
    y2: 2.51214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    stopColor: "#F2BC37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3627,
    stopColor: "#E09A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#D38235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    stopColor: "#CB7434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_9478_21983",
    x1: 3.4033,
    y1: 8.08683,
    x2: 3.4033,
    y2: 6.38345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_9478_21983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.18855 6.92228) scale(0.83663 0.836185)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3638,
    stopColor: "#FCCE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_9478_21983",
    x1: 3.40333,
    y1: 6.56079,
    x2: 3.40333,
    y2: 6.98334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    stopColor: "#F2BC37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3627,
    stopColor: "#E09A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#D38235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    stopColor: "#CB7434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_9478_21983",
    x1: 3.40351,
    y1: 6.94787,
    x2: 3.40351,
    y2: 7.29878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    stopColor: "#F2BC37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3627,
    stopColor: "#E09A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#D38235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    stopColor: "#CB7434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_9478_21983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(3.41805 6.76608) scale(0.243486 0.243491)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00850916,
    stopColor: "#FCCD38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3748,
    stopColor: "#FBB53A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7145,
    stopColor: "#FBA73B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBA23B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_9478_21983",
    x1: 5.38155,
    y1: 4.21433,
    x2: 4.26905,
    y2: 0.833293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_9478_21983",
    x1: 5.00056,
    y1: 2.43863,
    x2: 5.00056,
    y2: 4.52084,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_9478_21983",
    x1: 5.61988,
    y1: 4.67641,
    x2: 4.85964,
    y2: 2.69132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_9478_21983",
    x1: 5.47616,
    y1: 4.15662,
    x2: 4.5722,
    y2: 2.06943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1756,
    stopColor: "#D1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5059,
    stopColor: "#80DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_9478_21983",
    x1: 5.00088,
    y1: 1.95303,
    x2: 5.00088,
    y2: 3.23309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_9478_21983",
    x1: 6.65654,
    y1: 7.36145,
    x2: 6.65654,
    y2: 7.99892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EA5A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8EA5A8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_9478_21983",
    x1: 7.24279,
    y1: 9.33663,
    x2: 6.51044,
    y2: 5.56161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_9478_21983",
    x1: 7.11995,
    y1: 7.37156,
    x2: 5.65505,
    y2: 4.04131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_9478_21983",
    x1: 5.26331,
    y1: 6.31561,
    x2: 8.04662,
    y2: 6.31561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3541E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_9478_21983",
    x1: 6.65512,
    y1: 6.24311,
    x2: 6.65512,
    y2: 5.00501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#80DAFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_9478_21983",
    x1: 6.52451,
    y1: 4.31115,
    x2: 6.66356,
    y2: 7.00086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_9478_21983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.22294 6.60234) scale(1.63589 1.63502)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6419,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_9478_21983",
    x1: 6.65512,
    y1: 3.55053,
    x2: 6.65512,
    y2: 8.08729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_9478_21983",
    x1: 6.65512,
    y1: 5.17492,
    x2: 6.65512,
    y2: 5.29953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_9478_21983",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.56452 6.72222) scale(2.05157 2.05159)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3541E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#643800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_9478_21983",
    x1: 6.69036,
    y1: 5.17303,
    x2: 6.69036,
    y2: 5.37968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_9478_21983",
    x1: 4.13961,
    y1: 1.2836,
    x2: 5.31712,
    y2: 3.7512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099D6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_9478_21983",
    x1: 3.40369,
    y1: 4.78842,
    x2: 3.40369,
    y2: 5.73735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C2200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C2200",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_9478_21983",
    x1: 7.81631,
    y1: -0.381775,
    x2: 8.26956,
    y2: 1.20083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCCE38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1158,
    stopColor: "#F2BC37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3627,
    stopColor: "#E09A36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5986,
    stopColor: "#D38235"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8168,
    stopColor: "#CB7434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C86F34"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestaurants);
export default __webpack_public_path__ + "static/media/restaurants.9037139e3a17be0fd55a05c5885faf8b.svg";
export { ForwardRef as ReactComponent };